<template>
    <div
      :class="wrapperClasses"
      class="tw-grid md:tw-gap-8 tw-mt-4 tw-mb-8"
    >
      <aside itemprop="associatedMedia">
        <vue-image
          v-if="!isVideo"
          :alt="media.alt"
          :src="media.src"
          :link="link"
          :class="mediaClasses"
          fullWidth
          fullHeight
        />
        <vue-video
          v-if="isVideo"
          :alt="media.alt"
          :src="media.src"
          :class="mediaClasses"
          fullWidth
        />
      </aside>
      <article class="tw-mt-4 md:tw-mt-0">
        <text-block
          tag="span"
          :text="date"
          itemprop="dateline"
        />
        <text-block
          tag="h1"
          size="5"
          :text="title"
          :extraClasses="{
            'tw-text-black': true,
            'tw-uppercase': true,
            'tw-mt-0': true,
            'tw-mb-2': true,
            'tw-ml-0': true
          }"
          :link="link"
          lineDecoration="under"
          itemprop="headline"
        />
        <rich-text
          itemprop="abstract"
          :tag="abstractTag"
          :richText="abstract"
          :class="{'mobile:tw-hidden': isNewsList}"
          class="tw-mt-0"
        />
        <vue-button
          v-if="link"
          :square="true"
          :link="link"
          isLink
          :label="ctaLabel"
          class="tw-mt-8"
        />
      </article>
    </div>
</template>

<script>

import TextBlock from "@/stories/Atoms/TextBlock/TextBlock.vue";
import RichText from '@/stories/Atoms/RichText/RichText.vue';
import VueImage from '@/stories/Atoms/VueImage/VueImage.vue';
import VueVideo from '@/stories/Atoms/VueVideo/VueVideo.vue';
import VueButton from "@/stories/Atoms/Button/Button.vue";

export default {
  name: 'NewsArticle',
  components: {
    TextBlock,
    RichText,
    VueButton,
    VueImage,
    VueVideo,
   },
  props: {
    abstractTag: {
      type: String,
      required: false,
      default: "span"
    },
    ctaLabel: {
      type: String,
      required: false
    },
    date: {
      type: String,
      required: false
    },
    isNewsList: {
      type: Boolean,
      default: false,
      required: false
    },
    abstract: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    mediaType: {
      type: String,
      default: "image",
      validator(value) {
        return ["image", "video"].includes(value);
      },
      required: false
    },
    media: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
  },
  computed: {
    wrapperClasses() {
      return {
        "md:tw-grid-cols-2": this.isNewsList,
        "md:tw-grid-flow-col ": !this.isNewsList,
        "md:tw-auto-columns": !this.isNewsList,
      }
    },
    mediaClasses() {
      return {
        "tw-block": !this.isNewsList,
        "md:tw-max-w-none": !this.isNewsList,
        "md:tw-w-[34.5rem]": !this.isNewsList,
        "md:tw-h-[18rem]": !this.isNewsList,
        "lg:tw-w-[43.125rem]": !this.isNewsList,
        "lg:tw-h-[22.5rem]": !this.isNewsList,
      }
    },
    isVideo() {
      return this.mediaType === "video"
    },
  }
}
</script>
